/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestAbiDecode, TestAbiDecodeInterface } from "../TestAbiDecode";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    name: "Auction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "BuyOrder",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TestAbiDecode__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestAbiDecode> {
    return super.deploy(overrides || {}) as Promise<TestAbiDecode>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestAbiDecode {
    return super.attach(address) as TestAbiDecode;
  }
  connect(signer: Signer): TestAbiDecode__factory {
    return super.connect(signer) as TestAbiDecode__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestAbiDecodeInterface {
    return new utils.Interface(_abi) as TestAbiDecodeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestAbiDecode {
    return new Contract(address, _abi, signerOrProvider) as TestAbiDecode;
  }
}
